import React from 'react';
import { SectionHeaderProps } from '../../../types';

const SectionHeader: React.FC<SectionHeaderProps & React.HTMLAttributes<HTMLDivElement>> = React.memo(({ title, subtitle, href, label, children, ...rest }) => {
  const isInteractive = Boolean(href);

  return (
    <div
      className={`section-header-root w-full mb-6 ${isInteractive ? 'section-header-root--interactive' : ''}`}
      {...rest}
    >
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center gap-4 flex-1 min-w-0">
          {label && (
            <div className="text-xs font-medium uppercase tracking-[0.18em] text-textMuted">{label}</div>
          )}
          {href ? (
            <a 
              href={href} 
              target="_blank"
              rel="noopener noreferrer"
              className="group clickable-header flex-1 min-w-0 flex items-center gap-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-app)]"
              aria-label={title}
            >
              <div className="section-header-stack transition-colors duration-150 group-hover:text-[color-mix(in_srgb,var(--section-header-highlight) 85%, var(--text-primary) 15%)]">
                <span className="section-header-modern">{title}</span>
                {subtitle && <span className="section-header-subtitle">{subtitle}</span>}
              </div>
              <svg
                className="h-4 w-4 text-textMuted opacity-0 transition-opacity duration-150 group-hover:opacity-100 flex-shrink-0"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          ) : (
            <div className="section-header-stack flex-1 w-full">
              <span className="section-header-modern">{title}</span>
              {subtitle && <span className="section-header-subtitle">{subtitle}</span>}
            </div>
          )}
        </div>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
      <div className="section-header-divider" aria-hidden="true" />
    </div>
  );
});

SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;

